module.exports = __webpack_public_path__ + "static/media/grafismo-login.53cbcc9f.svg";